import React from "react";
import {BrowserRouter, Route} from "react-router-dom";
import Navbar from "./Components/Navbar/Navbar";
import Header from "./Components/Header/Header";
import "./App.sass"
import ProfileContainer from "./Components/Profile/ProfileContainer";
import {connect} from "react-redux";
import Login from "./Components/Login/Login";
import DialogsContainer from "./Components/Dialogs/DialogsContainer";
import UsersContainer from "./Components/Users/UsersContainer";
import FriendsContainer from "./Components/Friends/FriendsContainer";
import {editMenu, startApp} from "./Redux/appReducer";
import Preloader from "./Utilits/Preloader/Preloader";
import MainPageContainer from "./Components/MainPage/MainPageContainer";
import SettingsContainer from "./Components/Settings/SettingsContainer";

class App extends React.Component {

    componentDidMount() {
        this.props.startApp()
    }

    render() {
        if (!this.props.isStartApp)
            return <Preloader/>;
        return (
            <>
            <BrowserRouter basename={process.env.PUBLIC_URL}>
                <div className='main-app'>
                    <div className={(this.props.activePageSite === 'MAIN' || this.props.activePageSite === 'LOGIN') ? 'main-window-off' : null}>
                        <Header/>
                        <div className={"main_window " + (this.props.themeIsDark ? "dark-theme" : "")}>
                            <Navbar/>
                            <div onClick={() => this.props.editMenu(false)} className={this.props.isMenuOpen ? 'app-window menu-open' : "app-window"}>
                                <Route path='/profile/:id?' component={ProfileContainer}/>
                                <Route path='/dialogs/:id?' component={DialogsContainer}/>
                                <Route path='/users' component={UsersContainer}/>
                                <Route path='/friends' component={FriendsContainer}/>
                                <Route path='/settings' component={SettingsContainer}/>
                            </div>
                        </div>
                    </div>
                    <Route path='/' component={MainPageContainer} exact={true}/>
                    <Route path='/login' component={Login}/>
                </div>
            </BrowserRouter>
                </>
        );
    }
}


const mapStateToProps = (state) => {
    return {
        activePageSite: state.auth.activePageSite,
        isMenuOpen: state.appReducer.isMenuOpen,
        isStartApp: state.appReducer.isStartApp,
        themeIsDark: state.appReducer.themeIsDark
    }
};

export default connect(mapStateToProps, {startApp, editMenu})(App)